import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";

import Header from "../headers/light.js";

import { ReactComponent as SvgDecoratorBlob1 } from "../../images/svg-decorator-blob-1.svg";
import DesignIllustration from "../../images/design-illustration.svg";
import { Container } from "../misc/Layouts.js";
import { CALANDLY_MEET } from "../../config/constants.js";
// import CustomersLogoStripImage from "../../images/customers-logo-strip.png";

const TwoColumn = tw.div`flex flex-col lg:flex-row lg:items-center max-w-screen-xl mx-auto py-20 md:py-24`;
const LeftColumn = tw.div`relative lg:w-5/12 text-center max-w-lg mx-auto lg:max-w-none lg:text-left`;
const RightColumn = tw.div`relative mt-12 lg:mt-0 flex-1 flex flex-col justify-center lg:self-end`;

const Heading = tw.h1`font-bold text-3xl md:text-3xl lg:text-4xl xl:text-5xl text-gray-900 leading-tight animate-bounce`;
const Paragraph = tw.p`my-5 lg:my-8 text-base xl:text-lg`;


const Actions = styled.div`
  ${tw`relative max-w-md text-center mx-auto lg:mx-0 mt-8`}
  input {
    ${tw`sm:pr-48 pl-8 py-4 sm:py-5 rounded-full border-2 w-full font-medium focus:outline-none transition duration-300  focus:border-primary-500 hover:border-gray-500`}
  }
  a {
    ${tw`w-full bg-primary-500 text-gray-100 font-bold mr-2 my-4 sm:my-2 rounded-full py-4 flex items-center justify-center lg:w-40 sm:leading-none focus:outline-none hover:bg-primary-900 transition duration-300`} // sm:w-40  sm:absolute right-0 top-0 bottom-0 
  }
`;

const IllustrationContainer = tw.div`flex justify-center lg:justify-end items-center`;

// Random Decorator Blobs (shapes that you see in background)
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none opacity-5 absolute left-0 bottom-0 h-64 w-64 transform -translate-x-2/3 -z-10`}
`;

// const CustomersLogoStrip = styled.div`
//   ${tw`mt-12 lg:mt-20`}
//   p {
//     ${tw`uppercase text-sm lg:text-xs tracking-wider font-bold text-gray-500`}
//   }
//   img {
//     ${tw`mt-4 w-full lg:pr-16 xl:pr-32 opacity-50`}
//   }
// `;

export default ({ roundedHeaderButton, onClick }) => {
  return (
    <>
      <Header roundedHeaderButton={roundedHeaderButton} onClick={onClick ? onClick : () => {}} />
      <Container>
        <TwoColumn>
          <LeftColumn>
            <Heading>
              If you are not <span tw="text-primary-500">ONLINE</span><br /> You don't <span tw="text-primary-500">EXIST!</span>
            </Heading>
            <Paragraph>
              {/* Cultivate a Strong Online Presence with us. Our captivating landing pages ensure you're visible and memorable in the digital world. 
              Don't be invisible online, let us help you stand out. */}
              Get your hands on a stunning, custom-designed landing page at absolutely no cost! All you pay for are the domain and the hassle-free, comprehensive maintenance plan. Elevate your business's online presence without breaking the bank. Make your mark in the digital world with our cost-effective solution.
            </Paragraph>
            <Actions>
              {/* <input type="text" placeholder="Your E-mail Address" /> */}
              <a href={CALANDLY_MEET} target="_blank" rel="noreferrer">Let's talk</a>
            </Actions>
            {/* <CustomersLogoStrip>
              <p>Our TRUSTED Customers</p>
              <img src={CustomersLogoStripImage} alt="Our Customers" />
            </CustomersLogoStrip> */}
          </LeftColumn>
          <RightColumn>
            <IllustrationContainer>
              <img tw="min-w-0 w-full max-w-lg xl:max-w-3xl" src={DesignIllustration} alt="Design Illustration" />
            </IllustrationContainer>
          </RightColumn>
        </TwoColumn>
        <DecoratorBlob1 />
      </Container>
    </>
  );
};
